export const testAttr = (testId: string, testValue?: string) => ({
	...(testId ? { ['data-test-id']: testId } : {}),
	...(testValue ? { ['data-test-value']: testValue } : {}),
});
